export function* increment(from = 0): IterableIterator<number> {
  while (true) {
    yield from++;
  }
}

export function incrementFabric(from = 0, prefix?: string): () => number | string {
  const incrementGenerator = increment(from);

  return () => {
    const nextValue = incrementGenerator.next().value;

    return prefix ? `${prefix}-${nextValue}` : nextValue;
  };
}
